import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_escalation_status = _resolveComponent("select-escalation-status")!
  const _component_client_posts_toolbar = _resolveComponent("client-posts-toolbar")!

  return (_openBlock(), _createBlock(_component_client_posts_toolbar, {
    client: _ctx.client,
    filters: _ctx.filters,
    minimized: _ctx.minimized,
    "maximize-btn": _ctx.maximizeBtn,
    "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:filters', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_select_escalation_status, {
        value: _ctx.status,
        onChange: _ctx.selectStatus
      }, null, 8, ["value", "onChange"])
    ]),
    _: 1
  }, 8, ["client", "filters", "minimized", "maximize-btn"]))
}